export default __webpack_public_path__ + "static/media/hr-solutions-2.cd712261.svg";